export const CloseIcon = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0)">
            <path
                d="M14.3753 12.7812L10.0003 9.28119L5.62529 12.7812C5.52273 12.8633 5.40501 12.9243 5.27884 12.9609C5.15268 12.9975 5.02054 13.0089 4.88998 12.9944C4.75943 12.9799 4.633 12.9398 4.51792 12.8765C4.40284 12.8131 4.30137 12.7278 4.21929 12.6252C4.13722 12.5226 4.07615 12.4049 4.03957 12.2787C4.00299 12.1526 3.99161 12.0204 4.0061 11.8899C4.02059 11.7593 4.06065 11.6329 4.12399 11.5178C4.18734 11.4027 4.27273 11.3013 4.37529 11.2192L9.37529 7.21919C9.55266 7.07719 9.77309 6.99982 10.0003 6.99982C10.2275 6.99982 10.4479 7.07719 10.6253 7.21919L15.6253 11.2192C15.8324 11.385 15.9652 11.6262 15.9945 11.8899C16.0237 12.1536 15.9471 12.4181 15.7813 12.6252C15.6992 12.7278 15.5977 12.8131 15.4827 12.8765C15.3676 12.9398 15.2412 12.9799 15.1106 12.9944C14.8469 13.0236 14.5824 12.947 14.3753 12.7812Z"
                fill="#1B2D37"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <path d="M0 20L20 20L20 0L0 0L0 20Z" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
